var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAenaLostPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 4 C18.7 4 8 14.5 8 27.5 C 8 38 16 50 24 60 C 28 65 31 69 32 76 C 33 69 36 65 40 60 C 48 50 56 38 56 27.5 C 56 14.5 45.3 4 32 4 Z",
    stroke: "#1A2732",
    strokeWidth: 5,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 26,
    r: 8.5,
    stroke: "#1A2732",
    strokeWidth: 5,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAenaLostPin);
export default __webpack_public_path__ + "static/media/aena_lost_pin.dc22519cb7cc7b2b01e2bcb576c255b1.svg";
export { ForwardRef as ReactComponent };